import React, { memo } from 'react';

import SeatProgress from './SeatProgress';

interface SeatAvailabilityProps {
  availableProSeats: number;
  availableStandardSeats: number;
  totalProSeats: number;
  totalSeats: number;
  totalStandardSeats: number;
}

const SeatAvailability = ({
  availableProSeats,
  availableStandardSeats,
  totalProSeats,
  totalSeats,
  totalStandardSeats,
}: SeatAvailabilityProps) => {
  const widthStandardPercentage = (totalStandardSeats / totalSeats) * 100;
  const widthProPercentage = (totalProSeats / totalSeats) * 100;

  return (
    <div className="mt-28 flex max-w-[626px] flex-nowrap items-center gap-4">
      {totalProSeats > 0 && (
        <SeatProgress
          availableSeats={availableProSeats}
          totalSeats={totalProSeats}
          className="bg-pro-gold"
          widthPercentage={widthProPercentage}
        />
      )}
      {totalStandardSeats > 0 && (
        <SeatProgress
          availableSeats={availableStandardSeats}
          totalSeats={totalStandardSeats}
          className="bg-primary-magenta"
          widthPercentage={widthStandardPercentage}
        />
      )}
    </div>
  );
};

export default memo(SeatAvailability);
